import { __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { Input as Input$1 } from '@cheetahdigital/console-kit-cx';
import classNames from '../../../node_modules/classnames/index.js';
import { useCallback } from 'react';
import styles from './index.module.scss.js';

var Input = function (_a) {
    var id = _a.id, name = _a.name, autoComplete = _a.autoComplete, label = _a.label, value = _a.value, type = _a.type, error = _a.error, icon = _a.icon, onChange = _a.onChange, onBlur = _a.onBlur, placeholder = _a.placeholder, disabled = _a.disabled, isPointerEventsAuto = _a.isPointerEventsAuto, _b = _a.maxLength, maxLength = _b === void 0 ? 0 : _b;
    var handleChange = useCallback(function (event) {
        var _a;
        if (!onChange) {
            return;
        }
        if (maxLength) {
            var newEvent = __assign(__assign({}, event), { target: __assign(__assign({}, event.target), { value: (_a = event.target.value) === null || _a === void 0 ? void 0 : _a.slice(0, maxLength) }) });
            onChange(newEvent);
            return;
        }
        onChange(event);
    }, [maxLength, onChange]);
    return (jsx("div", __assign({ className: classNames(styles.input, isPointerEventsAuto && styles.isPointerEventsAuto) }, { children: jsx(Input$1, { autoComplete: autoComplete, id: id, name: name, isDisabled: disabled, placeholder: placeholder, label: label, value: value, type: type, icon: icon, isFluid: false, hasError: !!error, errorMessage: error ? error : "", onChange: handleChange, onBlur: onBlur }, void 0) }), void 0));
};

export { Input as default };
